// extracted by mini-css-extract-plugin
export default {"title":"eaa-z","warning":"faa-z","sizeOptionsLegendText":"gaa-z"};